<div class="mr-static mr-layout map-layout">
  <div class="mr-static__top">
    <h1 class="mr-static__title mr-generated-title-WP">Tabula imaginaria</h1>
  </div>
  <div class="mr-static__content map-layout__map-container">
    <!-- Mappa MyMaps -->
    <iframe
      src="https://www.google.com/maps/d/embed?mid=1r9wnslCTYq1u43dp0xrV1MDg86CANag&ehbc=2E312F"
      frameborder="0"
      class="map-layout__iframe map-layout__iframe-mymaps">
    </iframe>

    <!-- Mappa Leaflet totale -->
    <!-- <iframe
      src="/assets/maps/mapa_interactivo_sferamundi_completo.html"
      frameborder="0"
      class="map-layout__iframe map-layout__iframe-leaflet">
    </iframe> -->
  </div>
</div>
